import { useCallback } from 'react';

import { BookedConfirmationModalProps } from '~/components/common/modals/BookedConfirmationModal/BookedConfirmationModal';
import { useModal } from '~/contexts/ModalContext';
import { MappedInquiryView } from '~/types/mappedResponseTypes';
import { AccountVendorResultView } from '~/types/responseTypes';
import { DateValue } from '~/util/dateUtils';

import { ConnectedVendorModalProps } from '../../inquiries/components/ConnectedVendorsModal/ConnectedVendorsModal';

export interface BudgetResolutionModalProps {
  response: AccountVendorResultView;
  hideModalFn: () => void;
}

const dialogHeadingId = 'dialog-heading';

export const useBudgetResolutionModal = () => {
  const { showV2PredefinedModal } = useModal();

  const showBudgetResolutionModal = useCallback(
    (response: AccountVendorResultView) => {
      showV2PredefinedModal<BudgetResolutionModalProps>(
        'BUDGET_RESOLUTION_MODAL',
        {
          triggerRef: null,
          dialogHeadingId,
        },
        { response }
      );
    },
    [showV2PredefinedModal]
  );

  return { showBudgetResolutionModal };
};

export const useBookedConfirmationModal = () => {
  const { showV2PredefinedModal } = useModal();

  const showBookedConfirmationModal = useCallback(
    (vendorName: string, storefrontCoverId: string | null) => {
      showV2PredefinedModal<BookedConfirmationModalProps>(
        'BOOKED_VENDORS_CONFIRMATION_MODAL',
        {
          triggerRef: null,
          dialogHeadingId,
        },
        { vendorName, storefrontCoverId }
      );
    },
    [showV2PredefinedModal]
  );

  return { showBookedConfirmationModal };
};

export interface MarkBookedModalProps {
  inquiry: MappedInquiryView;
  hideModalFn: () => void;
  handleSuccess: (inquiry: MappedInquiryView) => void;
  showBudgetResolutionModal: (response: AccountVendorResultView) => void;
  showConnectedVendorsModal: (props: ConnectedVendorModalProps) => void;
}

export interface MarkBookedModalFormValues {
  priceCents: number;
  eventDate: DateValue;
}

export const useMarkBookedModal = () => {
  const { showV2PredefinedModal } = useModal();

  const showMarkBookedModal = useCallback(
    (
      inquiry: MappedInquiryView,
      handleSuccess: (updatedInquiry: MappedInquiryView) => void,
      showBudgetResolutionModal: (response: AccountVendorResultView) => void,
      showConnectedVendorsModal: (props: ConnectedVendorModalProps) => void
    ) => {
      showV2PredefinedModal<MarkBookedModalProps>(
        'MARK_BOOKED_MODAL',
        {
          triggerRef: null,
          dialogHeadingId,
        },
        {
          inquiry,
          handleSuccess,
          showBudgetResolutionModal,
          showConnectedVendorsModal,
        }
      );
    },
    [showV2PredefinedModal]
  );

  return { showMarkBookedModal };
};
